const userApiReducer = (state = "", action) => {
  switch (action.type) {
    case "storeUserInfoAPI":
      return action.payload;
    default:
      return state;
  }
};

export default userApiReducer;
